module.exports = __webpack_public_path__ + "tk.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/tk.svg
// module id = 1096
// module chunks = 0